'use client';
import { useMemo, useContext, createContext } from 'react';
import { generateUserAgentValues } from '@financial/app-js-interfaces';
import { throwContextError } from './utils.mjs';
import { jsx } from 'react/jsx-runtime';

const Context = /*#__PURE__*/createContext(undefined);
function UserAgentProvider(_ref) {
  let {
    userAgent,
    children
  } = _ref;
  const userAgentValues = useMemo(() => generateUserAgentValues(userAgent), [userAgent]);
  return /*#__PURE__*/jsx(Context.Provider, {
    value: {
      ...userAgentValues
    },
    children: children
  });
}
function useUserAgentContext() {
  const context = useContext(Context);
  if (context === undefined) {
    throwContextError('UserAgentProvider', 'useUserAgentContext');
  }
  return context;
}
function withUserAgent(Component) {
  return function UserAgentComponent(props) {
    return /*#__PURE__*/jsx(Context.Consumer, {
      children: values => /*#__PURE__*/jsx(Component, {
        userAgent: values,
        ...props
      })
    });
  };
}

export { UserAgentProvider, useUserAgentContext, withUserAgent };
